import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router';

import { useAuth } from '@/api/auth';

import '../market/market.css';
import './login.css';

export function VerifyEmailScreen() {
  const { verifySignup } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(location.hash.replace(/^#/, '')).get('token') ?? '';
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let current = true;
    if (!token) {
      setError('В ссылке нет токена подтверждения');
      return;
    }
    setError(null);
    void verifySignup(token)
      .then(() => { if (current) navigate('/search-profiles', { replace: true }); })
      .catch((cause: unknown) => {
        if (current) setError(cause instanceof Error ? cause.message : 'Не удалось подтвердить адрес');
      });
    return () => { current = false; };
  }, [navigate, token, verifySignup]);

  return <div className="market-page login-page"><section className="login-intro"><div className="login-brand"><span>TRAVEL</span><strong>CORTEX</strong><em>verification</em></div><div className="login-message"><span className="market-eyebrow">Подтверждение</span><h1>Активируем личное пространство.</h1></div></section><section className="login-access"><div className="login-form">{error ? <><p role="alert" className="login-error">{error}</p><p className="login-security"><Link to="/login">Вернуться ко входу</Link></p></> : <p role="status" className="login-notice">Проверяем одноразовую ссылку…</p>}</div></section></div>;
}
